// extracted by mini-css-extract-plugin
module.exports = {"modalCard":"ModalCard_modalCard__3D_QX"};